





























import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';

export enum PartialRejectionReason {
  NEW_VERSION = 'NEW_VERSION',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  USER_ACTION = 'USER_ACTION'
}

@Component({
  name: 'PartialRejectionNote',
})
export default class PartialRejectionNote extends Vue {
  @Prop({ type: Boolean, default: true })
  showNote!: boolean;

  @Prop({ type: String, required: false })
  reason?: PartialRejectionReason;

  @Prop({ type: Date, required: false })
  rejectionDate?: Date;

  @Prop({ type: String, required: false })
  customMessage?: string;

  @Prop({ type: String, required: false })
  additionalInfo?: string;

  @Prop({ type: Boolean, default: false })
  showCloseButton!: boolean;

  @Prop({ type: Boolean, default: false })
  compact!: boolean;

  @Prop({ type: String, default: 'warning' })
  severity!: 'warning' | 'error' | 'info';

  get noteTitle(): string {
    if (this.customMessage) {
      return this.$t('partialRejection.types.notification') as string;
    }

    switch (this.reason) {
      case PartialRejectionReason.NEW_VERSION:
        return this.$t('partialRejection.types.partialRejection') as string;
      case PartialRejectionReason.VALIDATION_ERROR:
        return this.$t('partialRejection.types.validationError') as string;
      case PartialRejectionReason.SYSTEM_ERROR:
        return this.$t('partialRejection.types.systemError') as string;
      case PartialRejectionReason.USER_ACTION:
        return this.$t('partialRejection.types.userAction') as string;
      default:
        return this.$t('partialRejection.types.notification') as string;
    }
  }

  get noteMessage(): string {
    if (this.customMessage) {
      return this.customMessage;
    }

    switch (this.reason) {
      case PartialRejectionReason.NEW_VERSION:
        return this.$t('partialRejection.descriptions.newVersion') as string;
      case PartialRejectionReason.VALIDATION_ERROR:
        return this.$t('partialRejection.descriptions.validationFailed') as string;
      case PartialRejectionReason.SYSTEM_ERROR:
        return this.$t('partialRejection.descriptions.systemError') as string;
      case PartialRejectionReason.USER_ACTION:
        return this.$t('partialRejection.descriptions.userRejected') as string;
      default:
        return this.$t('partialRejection.descriptions.default') as string;
    }
  }

  get noteClass(): string {
    const baseClass = 'note-base';
    const severityClass = `note-${this.severity}`;
    const compactClass = this.compact ? 'note-compact' : '';
    
    return [baseClass, severityClass, compactClass].filter(Boolean).join(' ');
  }

  get formattedRejectionDate(): string {
    if (!this.rejectionDate) return '';

    const now = moment();
    const date = moment(this.rejectionDate);
    
    if (now.diff(date, 'days') === 0) {
      return this.$t('partialRejection.time.today', { time: date.format('HH:mm') }) as string;
    } else if (now.diff(date, 'days') === 1) {
      return this.$t('partialRejection.time.yesterday', { time: date.format('HH:mm') }) as string;
    } else if (now.diff(date, 'days') > 1 && now.diff(date, 'years') < 1) {
      return date.format('D MMMM, HH:mm');
    } else {
      return date.format('DD.MM.YYYY, HH:mm');
    }
  }

  closeNote(): void {
    this.$emit('close');
  }

}
